import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Box, Button, Card, Flex, Text } from "rebass";
import { toastr } from "react-redux-toastr";
import { MdInsertDriveFile } from "react-icons/md";

import { bookCreated, bookFailed } from "../../../../store/modules/amplitude/actions";
import { setIsEdit } from "../../../../store/modules/display/actions";
import { closeModal } from "../../../../store/modules/modal/actions";

import { useCreateNewRecord, SuccessCallback, ErrorCallback, Errors } from "./useCreateNewRecord";

export const CreateRecord: React.FC = () => {
  const dispatch = useDispatch();
  const { replace } = useHistory();
  const successCallback = useCallback<SuccessCallback>((props) => {
    const { id, title, wordCount, startTimestamp, eventData } = props;

    dispatch(bookCreated({
      data: {
        book_id: id,
        book_title: title,
        book_num_words: wordCount,
        book_create_time_spent: Math.round(performance.now() - startTimestamp),
        ...eventData,
      },
    }));

    replace(`/record/${id}`);
    dispatch(closeModal());
    dispatch(setIsEdit(true));
  }, [dispatch, replace]);

  const errorCallback = useCallback<ErrorCallback>((props) => {
    const { message, eventData } = props;

    if (eventData) {
      dispatch(bookFailed({
        data: {
          book_id: "null",
          book_title: "Title",
          book_num_words: 0,
          ...eventData,
        },
      }));
    }

    const error = Errors[message] || ["Firebase", message];

    toastr.error(...error);
  }, [dispatch]);

  const createNewRecord = useCreateNewRecord(successCallback, errorCallback);

  return (
    <Flex
      height="100%"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Card
        width="50%"
        paddingBottom="37.5%"
        borderRadius=".25rem"
        bg="sp-blue-25"
        css="position: relative;"
      >
        <Box
          color="#fff"
          css="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"
        >
          <MdInsertDriveFile display="block" size={50} />
        </Box>
      </Card>

      <Text
        mt="15px"
        fontSize="18px"
        fontWeight={500}
        textAlign="center"
      >
        Take notes, write papers and more,
        <br />
        and review them in instant
      </Text>

      <Button
        mt="15px"
        color="#fff"
        bg="sp-blue"
        css="text-transform: capitalize;"
        onClick={createNewRecord}
      >
        new document
      </Button>
    </Flex>
  );
};
